module.exports = __webpack_public_path__ + "static/img/home_product_04_zh.5d4398e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_04_zh.png
// module id = 6PZ+
// module chunks = 34